import {
  USER_ADD_CART_ITEMS_LOADING,
  USER_ADD_CART_ITEMS_SUCCESS,
  USER_ADD_CART_ITEMS_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { createNewItemService } from "services/createNewItemService";
import { notification } from "antd";
import { userAddCartItemsUrl } from "api/apiUrls";

export const userAddCartItemsActions =
  (lang: any, userId: any, data: any, callback?: any) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: USER_ADD_CART_ITEMS_LOADING, payload: true });
      const response: any = await createNewItemService(
        `${userAddCartItemsUrl}/${lang}/user/${userId}/add`,
        data,
        "",
        "json"
      );

      if (response?.data?.is_success === true) {
        callback();
      } else {
        notification.error({
          message: `${response?.data?.error_msg[0]}`,
        });
      }

      dispatch({ type: USER_ADD_CART_ITEMS_SUCCESS, payload: response.data });
    } catch (err) {
      dispatch({ type: USER_ADD_CART_ITEMS_FAILURE, payload: err });
    } finally {
      dispatch({ type: USER_ADD_CART_ITEMS_LOADING, payload: false });
    }
  };
